import styled from "styled-components";

import BaseButton from "@/components/BaseButton";

export const StyledConfirmBtn = styled(BaseButton)`
    height: 46px;
`;

export const StyledConfirmBtnContainer = styled.div`
    margin-top: auto;
    position: sticky;
    bottom: 0;
    height: 46px;
`;
